import { render, staticRenderFns } from "./BannersCreate.vue?vue&type=template&id=c0c7a0f4&scoped=true"
import script from "./BannersCreate.vue?vue&type=script&lang=js"
export * from "./BannersCreate.vue?vue&type=script&lang=js"
import style0 from "./BannersCreate.vue?vue&type=style&index=0&id=c0c7a0f4&prod&lang=sass&scoped=true"
import style1 from "./BannersCreate.vue?vue&type=style&index=1&id=c0c7a0f4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c7a0f4",
  null
  
)

export default component.exports